"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ConfiguratorPackageSelector = void 0;

var _configuratorPackageSelector = _interopRequireDefault(require("./components/configurator-package-selector"));

exports.ConfiguratorPackageSelector = _configuratorPackageSelector["default"];